import React from 'react';

import { useIsXMediumAndAbove } from '../../../hooks/mediaQueries.js';
import TRANSLATIONS from '../../../translations/translations@default.json';

const SortByDefaultOption = () => {
	const isXMediumAndAbove = useIsXMediumAndAbove();

	return (
		<option
			key="default"
			value="default"
			disabled
			hidden
			data-testid="sort-by__option">
			{isXMediumAndAbove
				? TRANSLATIONS.controls.sortBy.pleaseSelect
				: TRANSLATIONS.controls.sortBy.sortByButton}
		</option>
	);
};

export default SortByDefaultOption;
